import { render, staticRenderFns } from "./GoingPublicCta.vue?vue&type=template&id=1cefe6c8"
import script from "./GoingPublicCta.vue?vue&type=script&lang=js"
export * from "./GoingPublicCta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./GoingPublicCta.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CImage: require('/vercel/path0/components/ui/c-image.vue').default,PriceCardBox: require('/vercel/path0/components/blocks/PriceCardBox.vue').default})
